"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFn = exports.tersifyFunctionByString = void 0;
var trim_js_1 = require("./trim.js");
function tersifyFunctionByString(fn, options) {
    var str = fn.toString();
    if (options.raw)
        return str;
    var struct = parseFn(str);
    switch (struct.type) {
        case 'function': return formatFn2(struct, options.maxLength);
        case 'arrow': return formatArrow2(struct, options.maxLength);
        case 'unknown':
        default:
            // istanbul ignore next
            return formatUnknown(struct, options.maxLength);
    }
}
exports.tersifyFunctionByString = tersifyFunctionByString;
/**
 * Note that we don't have to be exhaustive with the regex.
 * The input is from compilers's `fn.toString()`.
 * So they won't be too bad.
 */
var funcRegex = /^(async\s+)?function\s*(\*?)\s*(\w*)\s*\(([^)]*)\)\s*(\{.*\})$/ms;
var arrowRegex = /^(async\s*)?\(([^)]*)\)\s*=>(.*)$/ms;
var arrowSingleParamRegex = /^(async\s+)?(\w+)\s*=>(.*)$/ms;
function parseFn(input) {
    var _a, _b, _c, _d, _e, _f;
    var match = funcRegex.exec(input);
    if (match) {
        var body = getEnclosedBody(((_a = match[5]) !== null && _a !== void 0 ? _a : '').trim()).trim();
        return {
            type: 'function',
            async: !!match[1],
            generator: !!match[2],
            name: ((_b = match[3]) !== null && _b !== void 0 ? _b : '').trim(),
            params: ((_c = match[4]) !== null && _c !== void 0 ? _c : '').trim(),
            body: body
        };
    }
    match = arrowRegex.exec(input);
    if (match) {
        var params = ((_d = match[2]) !== null && _d !== void 0 ? _d : '').trim();
        var body = ((_e = match[3]) !== null && _e !== void 0 ? _e : '').trim();
        var singleLineBody = isSingleLineBody(body);
        body = removeLineBreaks(singleLineBody ? getSingleLineBody(body, Infinity) : getEnclosedBody(body)).trim();
        if (!singleLineBody && body.startsWith('return ') && body.endsWith(';')) {
            singleLineBody = true;
            body = body.slice(7, -1);
            if (body.startsWith('{')) {
                body = "(".concat(body, ")");
            }
        }
        return {
            type: 'arrow',
            async: !!match[1],
            params: params,
            body: body,
            singleParam: params.length > 0 && params.indexOf(',') === -1,
            singleLineBody: singleLineBody
        };
    }
    match = arrowSingleParamRegex.exec(input);
    if (match) {
        var body = ((_f = match[3]) !== null && _f !== void 0 ? _f : '').trim();
        var singleLineBody = isSingleLineBody(body);
        body = removeLineBreaks(singleLineBody ? getSingleLineBody(body, Infinity) : getEnclosedBody(body)).trim();
        if (!singleLineBody && body.startsWith('return ') && body.endsWith(';')) {
            singleLineBody = true;
            body = body.slice(7, -1);
            if (body.startsWith('{')) {
                body = "(".concat(body, ")");
            }
        }
        return {
            type: 'arrow',
            async: !!match[1],
            params: "".concat(match[2]),
            body: body,
            singleParam: true,
            singleLineBody: singleLineBody
        };
    }
    return {
        type: 'unknown',
        value: input
    };
}
exports.parseFn = parseFn;
function formatFn2(struct, maxLength) {
    var template = "".concat(struct.async ? 'async ' : '', "fn").concat(struct.generator ? '*' : '').concat(struct.name ? ' ' + struct.name : '', "(").concat(struct.params ? '%1' : '', ") {").concat(struct.body ? ' %2 ' : '', "}");
    var baseLength = struct.params && struct.body ? template.length - 4 :
        struct.params || struct.body ? template.length - 2 : template.length;
    struct.params = (0, trim_js_1.trim)({ raw: false, noTrim: false }, struct.params, Math.max(3, maxLength - baseLength - struct.body.length));
    struct.body = (0, trim_js_1.trim)({ raw: false, noTrim: false }, struct.body, Math.max(3, maxLength - baseLength - struct.params.length));
    return (0, trim_js_1.trim)({ raw: false, noTrim: false }, applyTemplate(template, struct), maxLength);
}
function formatArrow2(struct, maxLength) {
    var template = "".concat(struct.async ? 'async ' : '').concat(struct.singleParam ? '%1' : "(".concat(struct.params ? '%1' : '', ")"), " => ").concat(struct.singleLineBody ? '%2' : "{".concat(struct.body ? ' %2 ' : '', "}"));
    var baseLength = struct.params && struct.body ? template.length - 4 :
        struct.params || struct.body ? template.length - 2 : template.length;
    struct.params = (0, trim_js_1.trim)({ raw: false, noTrim: false }, struct.params, Math.max(3, maxLength - baseLength - struct.body.length));
    struct.body = (0, trim_js_1.trim)({ raw: false, noTrim: false }, struct.body, Math.max(3, maxLength - baseLength - struct.params.length));
    return (0, trim_js_1.trim)({ raw: false, noTrim: false }, applyTemplate(template, struct), maxLength);
}
// istanbul ignore next
function formatUnknown(struct, maxLength) {
    return (0, trim_js_1.trim)({ noTrim: false }, struct.value, maxLength);
}
function isSingleLineBody(str) {
    return !str.startsWith('{');
}
function getSingleLineBody(str, maxLength) {
    var struct = parseFn(str);
    switch (struct.type) {
        case 'function': return formatFn2(struct, maxLength);
        case 'arrow': return formatArrow2(struct, maxLength);
        default: return str.replace(/return;/g, '')
            .replace(/([\s([{])Symbol\(\)/g, '$1Sym()')
            .replace(/([\s([{])Symbol\.for\('([\w_]*)'\)/g, '$1Sym($2)')
            .replace(/([\s([{])Symbol\.for\("([\w_]*)"\)/g, '$1Sym($2)')
            .replace(/([\s([{])Symbol\.for\(`([\w_]*)`\)/g, '$1Sym($2)')
            .replace(/{\s+}/g, '{}');
    }
}
function getEnclosedBody(str) {
    var count = 1;
    str = str.slice(1);
    for (var i = 0; i <= str.length; i++) {
        if (str[i] === '}')
            count--;
        if (str[i] === '{')
            count++;
        if (count === 0) {
            var body = removeLineBreaks(str.slice(0, i));
            str = body.replace(/return;/g, '')
                .replace(/([\s([{])Symbol\(\)/g, '$1Sym()')
                .replace(/([\s([{])Symbol\.for\('([\w_]*)'\)/g, '$1Sym($2)')
                .replace(/([\s([{])Symbol\.for\("([\w_]*)"\)/g, '$1Sym($2)')
                .replace(/([\s([{])Symbol\.for\(`([\w_]*)`\)/g, '$1Sym($2)')
                .replace(/{\s+}/g, '{}');
            break;
        }
    }
    return str;
}
function removeLineBreaks(value) {
    return value.split('\n')
        .map(function (x) { return x.trim(); })
        .filter(function (x) { return !!x; })
        .map(function (x, i, a) { return i < a.length - 1
        && /[^({}):;(do|else)]$/.test(x)
        && /[^)}]/.test(a[i + 1]) ? x + ';' : x; }).join(' ');
}
function applyTemplate(template, struct) {
    if (struct.params) {
        template = template.replace('%1', struct.params);
    }
    if (struct.body) {
        template = template.replace('%2', struct.body);
    }
    return template;
}
//# sourceMappingURL=tersifyFunctionByString.js.map